import Selector from '@/components/ui/selector/selector';
export default Selector;
